import UserService from "api/user/user";

export default function MicrosoftGraphVoter() {
    const canAccessMicrosoftGraph = () => {
        return -1 !== UserService.getRoles().indexOf('ROLE_MODULE_MICROSOFT_GRAPH');
    }

    return ({canAccessMicrosoftGraph})
}
